module.exports = __webpack_public_path__ + "static/img/bill.4941994.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bill.png
// module id = 976
// module chunks = 1